<template>
  <div class="kyc-in-process" :class="{ block }">Dalam proses KYC</div>
</template>

<script>
export default {
  name: "KycInProcessLabel",
  props: {
    block: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.kyc-in-process {
  border: 1px solid #e8e337;
  color: #e8e337;
  padding: 4px 10px;
  border-radius: 3px;
  pointer-events: none;
  user-select: none;
  font-weight: 600;
  display: inline-block;
  text-align: center;
  background: transparent;
  cursor: default;
}
.kyc-in-process.block {
  display: block;
  width: 100%;
  padding: 10px 12px;
}
</style>
